/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Service Worker Release Prompt
 */
import React, { useEffect } from 'react';
import { App } from 'antd';
import { withErrorBoundary } from 'react-error-boundary';
import { approveUpdate, register } from './serviceWorkerRegistration';

let modalInstance: Record<'destroy', VoidFunction> | null = null;

/**
 * Release Prompt Component
 */
const ReleasePrompt: React.FC = () => {
	const { modal } = App.useApp();

	const destroyInstance = () => {
		modalInstance?.destroy();
		modalInstance = null;
	};

	const promptUpdate = (__, metadata: { version: string }) => {
		const modalProps = {
			width: 450,
			title: 'A newer version of our app is available.',
			content: `Reload and update to version ${metadata.version} ?`,
			okText: 'Update now',
			cancelText: 'Remind me in 5 mins',
			onOk: () => {
				approveUpdate();
				return false;
			},
		};
		setTimeout(
			() => {
				destroyInstance();
				modalInstance = modal.confirm({
					...modalProps,
					onCancel: () => {
						setTimeout(
							() => {
								destroyInstance();
								modalInstance = modal.warning({ ...modalProps });
							},
							5 * 60 * 1000,
						);
						return false;
					},
				});
			},
			5000, // 5 seconds
		);
	};

	useEffect(() => {
		// Disable service worker in development mode
		if (APP_MODE !== 'development') {
			register({ onUpdate: promptUpdate });
		}
	}, []);

	return null;
};

export default withErrorBoundary(ReleasePrompt, { fallbackRender: () => null });
